
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { UserService } from '../../../core/services/user.service';
import { Tab } from './../../../core/model/tab.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { EditModeService } from './../../../core/services/edit-mode.service';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { LmsModuleService } from './../../../core/services/lms-module.service';
import { MessageHandlerService } from './../../../core/services/message-handler.service';
import { PopupService } from './../../../core/services/popup.service';
import { LocoNote } from './../../model/loco-note.model';
import { NotesDetails } from './../../model/notes-details.model';
import { NotesDataService } from './../../services/note-data.service';


/**
 * @export
 * @class LmsNotesDataListComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-notes-data-list',
  templateUrl: './lms-notes-data-list.component.html',
  styleUrls: ['./lms-notes-data-list.component.scss']
})
export class LmsNotesDataListComponent implements OnInit, OnChanges {

  @Input() noteTextParent: string;
  noteText: string;
  @Input() loadData: NotesDetails;
  @Input() winCode: string;
  @Input() notesType: string;
  @Input() selectedTab: Tab;
  @Input() subTypes: string[];
  @Input() blankMessage: string;
  @Input() errorMessage: string;
  updateResponse: NotesDetails;
  editedList: Array<LocoNote> = [];
  configdata: any;
  startPage: Number;
  endPage: Number;
  showWarnPop: boolean;
  warnMessage: string;
  checkDelete: string;
  height: number;
  isEditForAdd: boolean;
  upperHeight = 285;
  tabLevel: number;
  tabLevelDialog: number;
  @ViewChild('viewPortPaging') viewPageDirective;


  /**
   * Creates an instance of LmsNotesDataListComponent.
   * @param {NotesDataService} notesDataService
   * @param {MessageHandlerService} messageHandlerService
   * @param {ConfigService} configService
   * @param {AppUtilityService} appUtilityService
   * @param {LmsLoaderService} lmsLoaderService
   * @param {EditModeService} editModeService
   * @param {LmsModuleService} lmsModuleService
   * @param {PopupService} popupService
   * @memberof LmsNotesDataListComponent
   */
  constructor(private notesDataService: NotesDataService, private messageHandlerService: MessageHandlerService,
    private configService: ConfigService, private appUtilityService: AppUtilityService, private lmsLoaderService: LmsLoaderService, private editModeService: EditModeService
    , private lmsModuleService: LmsModuleService, private popupService: PopupService, private lmsRendererService: LmsRendererService, private staticDataStoreService: StaticDataStoreService, 
    public user: UserService) {
    this.configdata = this.configService.getConfigData();
    this.tabLevel = this.configdata.tabIndex.detailPage;
    this.tabLevelDialog = this.configService.getConfigData().tabIndex.dialogBox;
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.calculatePageHeight();
      }
    });
  }

  ngOnInit() {
    this.calculatePageHeight();
  }

  private calculatePageHeight() {
    this.height = this.lmsRendererService.getWindowHeight() - this.upperHeight;
    if (this.lmsRendererService.getWindowWidth() < 1280) {
      this.height = this.height - 21;
    }
  }

  ngOnChanges() {
    this.noteText = this.noteTextParent;
    setTimeout(() => {
      if (this.viewPageDirective) {
        this.viewPageDirective.updateScreenSizeSetting();
      }
    }, 500);

  }

  setPageMode(btnId: string) {
    if (btnId && btnId.length > 0) {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(btnId);
    } else {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
    }
  }
  /**
    * This method gets Pagging Data
    * @param {any} $event
    * @memberOf LmsTerminalBoundComponent
    */
  getPagingdata($event) {
    this.startPage = $event.paging.start;
    this.endPage = $event.paging.end;
  }

  /**
   * This method add notes
   * @memberOf LmsNotesDataListComponent
   */
  public addNote() {
    this.lmsLoaderService.showLoader();
    let isNoteEdited = false;
    for (const note of this.loadData.listOfNotes) {
      if (note.editMode && note.editMode === 'Y') {
        isNoteEdited = true;
        break;
      }
    }
    if (!isNoteEdited) {
      const locoNote: LocoNote = {
        noteText: this.noteText.trim().toUpperCase()
      };
      this.notesDataService.addNote(locoNote, this.winCode, this.notesType, this.selectedTab).subscribe(
        (data) => {
          this.addNoteSubscribe(data);
        }, error => {
          this.noteError(error);
        });
    } else {
      this.updateNotes('');
    }
  }

  /**
   * @param {*} data
   * @memberof LmsNotesDataListComponent
   */
  addNoteSubscribe(data: any) {
    this.updateResponse = data;
    if (this.appUtilityService.isNumeric(this.updateResponse.priorityCode)) {
      const pCode = parseInt(this.updateResponse.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        this.lmsLoaderService.hideLoader();
        this.noteText = '';
        this.selectedTab.mode = 'view';
        this.checkEditModeStatus();
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
        this.notesDataService.load(this.selectedTab, this.winCode, this.notesType, true, this.updateResponse.messageText);
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      } else {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.subTypeDetail.notes.message = this.updateResponse.messageText;
        const editModeStatus = {
          status: false,
          message: ''
        };
        this.editModeService.setEditMode(editModeStatus);
        setTimeout(() => {
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
        }, 10);
        setTimeout(() => {
          this.checkEditModeStatus();
        }, 15);
      }
    }
  }

  /**
   * @param {*} error
   * @memberof LmsNotesDataListComponent
   */
  noteError(error: any) {
    this.lmsLoaderService.hideLoader();
    this.selectedTab.subTypeDetail.notes.message = this.appUtilityService.getHttpErroMessage(error, false);
    const editModeStatus = {
      status: false,
      message: ''
    };
    this.editModeService.setEditMode(editModeStatus);
    setTimeout(() => {
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }, 10);
    setTimeout(() => {
      this.checkEditModeStatus();
    }, 15);
  }

  /**
   * This method update Notes
   * @param {any} event
   * @memberOf LmsNotesDataListComponent
   */
  public updateNotes(event) {
    this.lmsLoaderService.showLoader();
    const editedList = [];
    this.loadData.listOfNotes.forEach(element => {
      if (element.editMode && element.editMode === 'Y') {
        const note = this.getUpdatedNote(element.editedNoteText);
        note.noteText = note.noteText.trim().toUpperCase();
        editedList.push(note);
      } else {
        const note = this.getUpdatedRemainingNote(element);
        editedList.push(note);
      }
    });
    if (this.noteText && this.noteText !== '') {
      const note = this.getUpdatedNote(this.noteText);
      note.noteText = note.noteText.trim().toUpperCase();
      editedList.push(note);
    }
    const updatedNotesRequest = this.getUpdatedNotesList(editedList);
    this.notesDataService.updateNote(this.selectedTab, updatedNotesRequest, this.winCode, this.notesType).subscribe(
      (data) => {
        this.updateNoteSubscribe(data);
      }, error => {
        this.noteError(error);
      });
  }

  /**
   * @param {*} data
   * @memberof LmsNotesDataListComponent
   */
  updateNoteSubscribe(data: any) {
    this.updateResponse = data;
    if (this.appUtilityService.isNumeric(this.updateResponse.priorityCode)) {
      const pCode = parseInt(this.updateResponse.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.mode = 'view';
        this.noteText = '';
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
        this.checkEditModeStatus();
        this.notesDataService.load(this.selectedTab, this.winCode, this.notesType, true, this.updateResponse.messageText);
        this.resetDefaultPageMode();
      } else {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.subTypeDetail.notes.message = this.updateResponse.messageText;
        const editModeStatus = {
          status: false,
          message: ''
        };
        this.editModeService.setEditMode(editModeStatus);
        setTimeout(() => {
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
        }, 10);
        setTimeout(() => {
          this.checkEditModeStatus();
        }, 15);
      }
    }
  }

  /**
   * @private
   * @param {string} noteText
   * @returns
   * @memberOf LmsNotesDataListComponent
   */
  private getUpdatedNote(noteText: string) {
    const note = {
      noteText: noteText
    };
    return note;
  }

  /**
   * @private
   * @param {LocoNote} data
   * @returns
   * @memberOf LmsNotesDataListComponent
   */
  private getUpdatedRemainingNote(data: LocoNote) {
    const note = {
      noteText: data.noteText ? data.noteText.toUpperCase() : '',
      timestamp: data.timestamp,
      userIdentifier: data.userIdentifier
    };
    return note;

  }

  /**
   * @private
   * @param {Array<LocoNote>} notes
   * @returns
   * @memberOf LmsNotesDataListComponent
   */
  private getUpdatedNotesList(notes: Array<LocoNote>) {
    const updatedNotes = {
      listOfNotes: notes
    };
    return updatedNotes;
  }

  /**
   * This method cancel note functionality
   * @param {any} event
   * @memberOf LmsNotesDataListComponent
   */
  public cancelNotes(event) {
    this.selectedTab.mode = 'view';
    this.noteText = '';
    this.loadData.listOfNotes.forEach(element => {
      if (element.editMode) {
        element.editMode = '';
        element.editedNoteText = element.noteText;
      }
    });
    this.checkEditModeStatus();
  }

  /**
   * @private
   * @memberOf LmsNotesDataListComponent
   */
  private checkEditModeStatus() {
    if (this.selectedTab && this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status === 'loaded' && this.selectedTab.mode === 'edit') {
      const editModeStatus = {
        status: true,
        message: this.configdata.messages.editModePopUp
      };
      this.editModeService.setEditMode(editModeStatus);
    } else {
      const editModeStatus = {
        status: false,
        message: ''
      };
      this.editModeService.setEditMode(editModeStatus);
    }
  }

  /**
  * @memberOf LmsTabsComponent
  */
  hideWarnPopup() {
    this.showWarnPop = false;
    this.warnMessage = '';
  }

  /**
   * This me
   * @memberOf LmsNotesDataListComponent
   */
  continueDeleteAll() {
    this.selectedTab.mode = 'view';
    this.lmsModuleService.updateSelectedTab(this.selectedTab);
    this.checkEditModeStatus();
    this.hideWarnPopup();
    if ('deleteAll' === this.checkDelete) {
      this.deleteAllNotes();
    } else if ('delete' === this.checkDelete) {
      this.deleteNote();
    }

  }

  /**
   * @param {any} event
   * @memberOf LmsNotesDataListComponent
   */
  showDeletePopUp(event) {
    this.showWarnPop = true;
    this.checkDelete = event;
    this.popupService.setPageMode('Dialog');
    this.popupService.setSubmitBtnId('confirmDialogButton');
    if (this.editModeService.isEditMode) {
      if ('deleteAll' === event) {
        this.warnMessage = this.configdata.messages.editModePopUp;
      } else if ('delete' === event) {
        this.warnMessage = this.configdata.messages.editModePopUp;
      }
    } else {
      if ('deleteAll' === event) {
        this.warnMessage = this.configdata.messages.deleteAllNote;
      } else if ('delete' === event) {
        this.warnMessage = this.configdata.messages.deleteSelectedNote;
      }
    }
  }

  /**
   * This method delete all notes
   * @memberOf LmsNotesDataListComponent
   */
  public deleteAllNotes() {
    this.lmsLoaderService.showLoader();
    this.resetDefaultPageMode();
    this.notesDataService.deleteAllNote(this.winCode, this.notesType, this.selectedTab).subscribe(
      (data) => {
        this.deleteAllNoteSubscribe(data);
      }, error => {
        this.noteError(error);
      });

  }

  /**
   * @param {*} data
   * @memberof LmsNotesDataListComponent
   */
  deleteAllNoteSubscribe(data: any) {
    this.updateResponse = data;
    if (this.appUtilityService.isNumeric(this.updateResponse.priorityCode)) {
      const pCode = parseInt(this.updateResponse.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
        this.notesDataService.load(this.selectedTab, this.winCode, this.notesType, true, this.updateResponse.messageText);
        this.selectedTab.mode = 'view';
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      } else {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.subTypeDetail.notes.message = this.updateResponse.messageText;
        const editModeStatus = {
          status: false,
          message: ''
        };
        this.editModeService.setEditMode(editModeStatus);
        setTimeout(() => {
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
        }, 10);
        setTimeout(() => {
          this.checkEditModeStatus();
        }, 15);
      }
    }
  }


  /**
   * @param {any} event
   * @memberOf LmsNotesDataListComponent
   */
  public clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.notes.message = '';
    const editModeStatus = {
      status: false,
      message: ''
    };
    this.editModeService.setEditMode(editModeStatus);
    setTimeout(() => {
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
    }, 5);
    setTimeout(() => {
      this.checkEditModeStatus();
    }, 10);
  }

  /**
   * This method delete particular node
   * @memberOf LmsNotesDataListComponent
   */
  public deleteNote() {
    this.lmsLoaderService.showLoader();
    const editedList = [];
    this.loadData.listOfNotes.forEach(element => {
      if (!(element.isDeleted && element.isDeleted === 'Y')) {
        const note = this.getUpdatedRemainingNote(element);
        editedList.push(note);
      }
    });
    const updatedNotesRequest = this.getUpdatedNotesList(editedList);
    this.resetDefaultPageMode();
    this.notesDataService.deleteNote(updatedNotesRequest, this.winCode, this.notesType, this.selectedTab).subscribe(
      (data) => {
        this.deleteNoteSubscribe(data);
      }, error => {
        this.noteError(error);
      });
  }

  /**
   * @param {*} data
   * @memberof LmsNotesDataListComponent
   */
  deleteNoteSubscribe(data: any) {
    this.updateResponse = data;
    if (this.appUtilityService.isNumeric(this.updateResponse.priorityCode)) {
      const pCode = parseInt(this.updateResponse.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.mode = 'view';
        this.noteText = '';
        this.selectedTab.subTypeDetail[this.selectedTab.subType.toLowerCase()].status = 'refresh';
        this.notesDataService.load(this.selectedTab, this.winCode, this.notesType, true, this.updateResponse.messageText);
      } else {
        this.lmsLoaderService.hideLoader();
        this.selectedTab.subTypeDetail.notes.message = this.updateResponse.messageText;
        const editModeStatus = {
          status: false,
          message: ''
        };
        this.editModeService.setEditMode(editModeStatus);
        setTimeout(() => {
          this.lmsModuleService.updateSelectedTab(this.selectedTab);
        }, 10);
        setTimeout(() => {
          this.checkEditModeStatus();
        }, 15);
      }
    }
  }

  /**
   * This method determines if the page would be in edit mode or not while adding a note.
   * @memberOf LmsNotesDataListComponent
   */
  public setEditModeForAdd() {
    if (this.noteText && this.noteText.trim().length > 0) {
      if (this.selectedTab.mode !== 'edit' || this.popupService.getSubmitBtnId() !== 'notesAddUpdateBtn') {
        this.selectedTab.mode = 'edit';
        this.isEditForAdd = true;
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
        this.checkEditModeStatus();
        this.popupService.setPageMode('Edit');
        this.popupService.setSubmitBtnId('notesAddUpdateBtn');
      }
    } else if (this.isEditForAdd) {
      this.selectedTab.mode = 'view';
      this.lmsModuleService.updateSelectedTab(this.selectedTab);
      this.checkEditModeStatus();
    }
  }

  /**
   * @memberof LmsNotesDataListComponent
   */
  removeFocusToAddUpdateBtn() {
    setTimeout(() => {
      this.popupService.setPageMode('');
      this.popupService.setSubmitBtnId('');
    }, 50);
  }

  /**
   * reset the page
   * @memberOf LmsNotesDataListComponent
   */
  resetDefaultPageMode() {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  /**
   * @param {any} event
   * @memberof LmsNotesDataListComponent
   */
  public isEditForAddEvent(event) {
    this.isEditForAdd = false;
  }
}
